export default __webpack_public_path__ + "static/media/chooseOwn.dbe9cdf1.png";